module.exports = __webpack_public_path__ + "img/Realisme_Det_moderne_gjennombruddet1.cc4f4ae7.jpg";